export default {
    isObject(obj) {
        return obj instanceof Object && obj.constructor === Object;
    },

    isEmptyObject(obj) {
        return (
            obj &&
            Object.keys(obj).length === 0 &&
            Object.getPrototypeOf(obj) === Object.prototype
        );
    },

    isObjectInArray(arr) {
        return arr.some((el) => this.isObject(el));
    },

    isObjectsEqual(obj1, obj2) {
        return (
            Object.keys(obj1).length === Object.keys(obj2).length &&
            Object.keys(obj1).every((prop) => {
                return obj1[prop] === obj2[prop];
            })
        );
    },

    arraysInObjectIsEmpty(obj) {
        return Object.values(obj).every((val) => Array.isArray(val) && val.length === 0);
    },

    isArraysEqual(arr1, arr2) {
        return (
            arr1.length === arr2.length &&
            arr1.every((obj, idx) => this.isObjectsEqual(obj, arr2[idx]))
        );
    },

    capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    },
};
